// Elakay Permission Center -- frontend mirror of canAccessElakayPage().
//
// DISPLAY AND NAVIGATION ONLY. The list comes from /readMe
// (infoSource.individualPermissions), already filtered by the server (kill
// switch, Switch Role, suspension, revocation, expiration, catalogue). Every
// protected API re-checks on its own; nothing here is a security decision.
// It never touches Family()/Seller()/..., ROLE_INHERITANCE or Switch Role.
import catalog from "./permissionCatalog.json";
import { getSelectedRoleOverride, normalizeWallRole } from "../pageInside/Rolle";

const byKey = new Map(catalog.entries.map((entry) => [entry.pageKey, entry]));

export const PERMISSION_CATALOG = catalog;
export const getCatalogEntry = (pageKey) => byKey.get(pageKey) || null;

/** Valid individual permissions of the signed-in user ([] while a Switch Role is active). */
export const getIndividualPermissions = (infoSource) => {
  if (getSelectedRoleOverride() || infoSource?.selectedRole) return [];
  return Array.isArray(infoSource?.individualPermissions) ? infoSource.individualPermissions : [];
};

export const canAccessElakayPage = ({ infoSource, pageKey, action = "view", now = new Date() }) => {
  const entry = getCatalogEntry(pageKey);
  if (!entry || entry.delegationStatus !== "CANDIDATE_V1" || !entry.allowedActions.includes(action)) return false;
  return getIndividualPermissions(infoSource).some((grant) => grant.pageKey === pageKey
    && Array.isArray(grant.actions) && grant.actions.includes(action)
    && (!grant.expiresAt || new Date(grant.expiresAt).getTime() > now.getTime()));
};

/** True when the page is open to the user through a permission (any action of the page). */
export const hasPageGrant = (infoSource, pageKey) => {
  const entry = getCatalogEntry(pageKey);
  return Boolean(entry) && entry.allowedActions.some((action) => canAccessElakayPage({ infoSource, pageKey, action }));
};

/**
 * Permission Center link visibility (display only): the configured owner
 * (server flag from /readMe) or any account whose REAL role is Family, even
 * during a Switch Role. The page itself is always decided by the server.
 */
export const canSeePermissionCenterLink = (infoSource) => infoSource?.permissionCenterOwner === true
  || normalizeWallRole(infoSource?.realRole) === "Family";
